import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  fontWeightMedium,
  font14,
} from 'approot/shared/styles/typography.style';
import { spacing4, spacing16 } from 'approot/shared/styles/spacing.style';
import { red1, red8 } from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { LinkButton } from 'approot/shared/styles/buttons/buttons';

type ErrorMessageProps = {
  centreText?: boolean;
  marginBottom?: number;
  marginTop?: number;
  bold?: boolean;
  background?: boolean;
};

const ErrorMessageStyled = styled.div<ErrorMessageProps>`
  ${font14}
  color: ${red8};

  margin-top: ${props =>
    props.marginTop || props.marginTop === 0
      ? `${rem(props.marginTop)};`
      : `${rem(spacing4)};`};

  ${({ bold }) =>
    bold &&
    `
    font-weight: ${fontWeightMedium};
  `}

  ${({ centreText }) =>
    centreText &&
    `
    text-align: center;
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom: ${rem(marginBottom)};
  `}

  ${({ background }) =>
    background &&
    `
    background-color: ${red1};
    padding: ${rem(spacing16)};
    border-radius: ${rem(borderRadius8)};
  `}

  ${LinkButton}, a {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  a {
    display: inline-block; // sets the height to the line height, to be consistent with LinkButton
  }
`;

export default ErrorMessageStyled;
